<div [@tab]="active() ? 'open' : 'closed'" (@tab.done)="handleAnimationDone(active())">
  <ng-content></ng-content>
</div>
